// Начало любой записи матча — те же служебные действия, что сервер диспатчит
// при старте партии (см. performStartGame): ими состояние поднимается разом,
// иначе полю нечего рисовать. Все, что идет после этого префикса, — уже сам
// игровой процесс, и он проигрывается с паузами (см. ReplayRunner)
const BOOTSTRAP_ACTION_TYPES = new Set([
  'SET_GAME_TYPE',
  'LOAD_STATE',
  'SET_PLAYERS',
  'SET_POLICY_MARKET',
  'START_GAME',
]);

/**
 * Делит запись матча на служебный префикс и игровые действия.
 * @param {Array} actions - записанные действия матча
 * @returns {{bootstrapActions: Array, gameplayActions: Array}}
 */
export const splitReplayBootstrapActions = (actions) => {
  const recordedActions = actions || [];
  let stopIndex = 0;
  while (stopIndex < recordedActions.length
    && BOOTSTRAP_ACTION_TYPES.has(recordedActions[stopIndex]?.type)) {
    stopIndex += 1;
  }

  return {
    bootstrapActions: recordedActions.slice(0, stopIndex),
    gameplayActions: recordedActions.slice(stopIndex),
  };
};

/**
 * Применяет служебный префикс записи. SET_GAME_TYPE из записи пропускается:
 * там сохранен ONLINE, а тип игры к этому моменту уже выставлен в REPLAY
 * снаружи — иначе воспроизведение переключилось бы обратно на сетевой режим.
 */
export const dispatchReplayBootstrapActions = (dispatch, bootstrapActions) => {
  (bootstrapActions || []).forEach((action) => {
    if (action.type === 'SET_GAME_TYPE') return;
    dispatch(action);
  });
};
